import React, { useState, useEffect, useRef } from 'react';
import NotificationPanels from '../NotificationPanels';
import ClientHeader from '../Partials/ClientHeader';
import ClientSideBar from '../Partials/ClientSideBar';
import Header from '../Header';
import Sidebar from '../Sidebar';
import CandidateTab from '../CandidateTab';
import Footer from '../Footer';
// import { useDispatch, useSelector} from 'react-redux';
// import { getCourtRecordCheckDeclarationDetails } from '../../Actions/courtRecordCheckDeclarationAction';
import MainFormCourtRecordCheckDeclaration from './MainFormCourtRecordCheckDeclaration';
import { useDispatch } from 'react-redux';
import { getCourtRecordCheckData } from '../../Actions/CourtRecordCheckActions';
import Loader from '../Common/loader';
import { useNavigate } from 'react-router-dom';
import ProgressHeading from '../Common/ProgressHeading';


const CourtRecordCheckDeclaration = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const form = useRef();
    const [role, setRole] = useState();
    const [formData, setFormData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    // const [courtRecordCheckDeclaration, setCourtRecordCheckDeclaration] = useState({});
    // const dispatch = useDispatch();
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            // dispatch(getCourtRecordCheckDeclarationDetails());
            dispatch(getCourtRecordCheckData(getDataCallback));
            console.log("getCourtRecordCheckDeclarationDetails")
        }
        fetchData();
    }, []);

    const getDataCallback = (data) => {
        console.log(data);
        if(data?.data?.group && data?.data?.group?.group_id == "profile_preview"){
            handleSubmitForPreview();
        }
        setFormData(data?.data);
        setIsLoading(false);
    }

    const handleSubmitForPreview = () => {
        const currentUrl = window.location.href;
        const [partA, partB] = currentUrl.split("/check-detail/");
        const [reference, route] = partB.split("/");
        navigate(`/case-initiation/profile-preview/${reference}`);
      };

    return (
        <>
            {isLoading && <Loader />}
            <NotificationPanels />
            {role === "EP" ? <ClientHeader /> : <Header />}
            {role === "EP" ? <ClientSideBar /> : <Sidebar />}
            <section className="main-section candidate-tab-form" style={{ paddingTop: '60px' }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-auto w-100-mbl bg-gray-mbl">
                            <ProgressHeading/>
                            <CandidateTab activeTab={"CourtRecordCheckDeclaration Details"} />
                        </div>
                        <div className="col bg-gray-mbl">
                            {/*Form*/}
                            <form ref={form} className="p-3 form2 form-section" style={{height: '90vh'}}>
                                <MainFormCourtRecordCheckDeclaration formData={formData} CandidateDetails={formData?.formData}/>
                            </form>

                            <Footer />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CourtRecordCheckDeclaration